import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Box, useTheme } from '@mui/material';

import { BaseText } from 'pages/ParentHelper/components/Chat/components/Body/components/BaseText';
import { MARGIN_SPACING_WITHOUT_AVATAR } from 'pages/ParentHelper/components/Chat/components/Body/constants';

import { FeedbackButtons } from './components/FeedbackButtons';
import { Wrapper } from './components/Wrapper';
import { useGivenFeedback } from './hooks';

import type { AnswerProps } from './types';
import type { FC } from 'react';

export const Answer: FC<AnswerProps> = ({
  answer,
  withoutAvatar,
  isAnswerLiked,
  withoutFeedback,
  messageId,
}) => {
  const theme = useTheme();
  const givenFeedback = useGivenFeedback(isAnswerLiked);

  if (!answer) return null;

  return (
    <Wrapper
      avatarContent={!withoutAvatar && <SupportAgentIcon />}
      sx={{
        marginLeft: {
          md: theme.spacing(withoutAvatar ? MARGIN_SPACING_WITHOUT_AVATAR : 0),
        },
        paddingBottom: {
          md: theme.spacing(withoutAvatar ? 1 : 2),
        },
      }}
    >
      {givenFeedback}
      <Box position="relative">
        <BaseText>{answer}</BaseText>
        {!givenFeedback && !withoutFeedback && (
          <FeedbackButtons messageId={messageId} />
        )}
      </Box>
    </Wrapper>
  );
};
